var AdminModule = /** @class */ (function () {
    function AdminModule() {
    }
    return AdminModule;
}());
export { AdminModule };
